export const CharacterIds = {
  "Absorbing Man": 6,
  "Arnim Zola": 18, //Zola does not exist, given random
  Avengers: 34,
  Beast: 75,
  Bishop: 92,
  "Black Bolt": 96,
  "Black Cat": 99,
  "Black Panther": 106,
  Blade: 112,
  Blizzard: 116,
  Boomerang: 141,
  Bullseye: 141,
  Cable: 145,
  "Cable (Deadpool)": 145,
  "Captain America": 149,
  "Captain Marvel (Carol Danvers)": 156,
  Chameleon: 170,
  "Chase Stein": 202,
  Cloak: 180,
  "Colleen Wing": 345,
  Colossus: 185,
  Cyclops: 196,
  Daredevil: 201,
  Deadpool: 213,
  "Doctor Strange": 226,
  Domino: 227,
  "Dragon Man": 233, //does not exist, give Dr Manhattan
  Falcon: 251,
  "Fantastic Four": 260, //given Firestorm
  "Gertrude Yorkes": 146,
  "Ghost Rider (Johnny Blaze)": 280,
  "Goliath (Bill Foster)": 291,
  "GW Bridge": 307, //given han solo
  "Hank Pym": 31,
  "Hawkeye (Kate Bishop)": 314,
  "Heroes For Hire": 321,
  Hulkling: 332,
  "Human Torch": 333,
  Inhumans: 343,
  "Invisible Woman": 344,
  "Iron Man": 346,
  "J. Jonah Jameson": 357, //given jean-Luc-Picard
  "Jack O' Lantern": 351,
  Joystick: 365, //given jj collosus
  "Kate Bishop": 314,
  Kingpin: 391,
  "Luke Cage": 416,
  Magneto: 423,
  "Maria Hill": 433, //given marvel girl
  "Mary Jane Watson": 435, //master cheif
  Medusa: 441,
  "Molly Hayes": 336,
  "Molten Man": 467,
  "Moon Knight": 470,
  "Mr. Fantastic": 456,
  Namor: 482,
  "New Warriors": 489, //Nick Fury
  "Nico Minoru": 610, //Songbird
  Owl: 538, //Nite Owl
  Patriot: 502, //One Punch Man
  "Professor X": 527,
  Prowler: 528,
  Puma: 106,
  Punisher: 530,
  "Radioactive Man": 538, // Ra's al gul
  "Red Skull": 550,
  Rhino: 556,
  Rogue: 567,
  Runaways: 583, //sentry
  "S.H.I.E.L.D": 583, //sentry
  Shatterstar: 588,
  "She-Hulk (Jennifer Walters)": 589,
  "Shocker (Herman Schultz)": 591,
  Silvermane: 596, //silver spectre
  "Sister Grimm": 610, //songbird
  Speed: 615,
  "Speedball (Robert Baldwin)": 614,
  "Spider-Man (Peter Parker)": 620,
  "Spider-Woman (Jessica Drew)": 623,
  Stature: 634,
  Storm: 638,
  "Sub-Mariner": 482,
  Swordsman: 639, //StormTrooper
  "Talkback (Chase Stein)": 202,
  Thing: 658,
  Thor: 659,
  Thunderbolts: 659,
  "Tigra (Greer Nelson)": 667,
  "Tony Stark": 346,
  "Venom (Mac Gargan)": 687,
  Vision: 697,
  Warbird: 704,
  Wasp: 708,
  Wiccan: 659,
  "Winter Soldier": 714,
  Wolverine: 717,
  "X-Men": 724,
  "Young Avengers": 726, //yellow jacket
  Excalibur: 726, //yellow jacket
  "Franklin Richards": 235,
  Galactus: 273,
  Hawkeye: 314,
  Hydra: 726, //yellow jacket
  "Scarlet Witch": 579,
  "Valeria Richards": 136,
};
